import { render, staticRenderFns } from "./DiscoverTabs.vue?vue&type=template&id=68aca44c&"
import script from "./DiscoverTabs.vue?vue&type=script&lang=js&"
export * from "./DiscoverTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports